import { MasterService } from '../../home/services/master.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})

export class ConfirmationModalComponent implements OnInit {

  public RfId: number;
  // tslint:disable-next-line:max-line-length
  constructor(public dialogRef: MatDialogRef<ConfirmationModalComponent>, @Inject(MAT_DIALOG_DATA) data, public masterService: MasterService) {
    this.RfId = data;
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }


  sendConfirm() {
    const url = '/invoice_products/print_barcode';
    // tslint:disable-next-line:variable-name
    const form_data = { id: this.RfId , token: localStorage.getItem('token') };
    this.masterService.addEditRecord(form_data, url).subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.close();
        }
      });
  }

}
